import { Component, Inject, OnInit } from "@angular/core";

import { ContactInformations } from "../../../Models/Contact-informations";
import { ContactInformationsService } from "../../../Services/contact-informations.service";

@Component({
    selector: "app-service-commercial",
    templateUrl: "./service-commercial.component.html",
    styleUrls: ["./service-commercial.component.scss"],
    standalone: false
})
export class ServiceCommercialComponent implements OnInit {
  contactInformation?: ContactInformations;

  constructor(
   
    private contactInformationsService: ContactInformationsService
  ) {}

  ngOnInit(): void {
    this.contactInformationsService
      .getContactInformations()
      .subscribe((res) => {
        this.contactInformation = res;
      });
  }

  closeKeyDialog() {
  }

  /*sentMail(){
    window.location.href = "mailto:" + this.contactInformation?.wissalInfoEmail;
  }*/
  sentMail(): void {
    window.open("mailto:" + this.contactInformation?.wissalInfoEmail);
  }
  /*callWissal(){
    window.location.href = "tel:" + this.contactInformation?.wissalPhoneNumber;
  }*/
  callWissal(): void {
    window.open("tel:" + this.contactInformation?.wissalPhoneNumber);
  }

  getCommercialState(): string {
    const storeOpen = 8 * 60 + 30; // in minutes
    const storeClosed = 21 * 60; // in minutes
    var now = new Date();
    var currentTime = now.getHours() * 60 + now.getMinutes(); // Minutes since Midnight

    if (currentTime >= storeOpen && currentTime <= storeClosed) {
      return "OUVERT";
    } else {
      return "FERMÉ";
    }
  }

  getTimingStoreIsOpened(): string {
    const storeOpen = 8 * 60 + 30; // in minutes
    const storeClosed = 17 * 60; // in minutes
    var now = new Date();
    var day = now.getDay(); // 5: Friday
    var currentTime = now.getHours() * 60 + now.getMinutes(); // Minutes since Midnight

    if (currentTime >= storeOpen && currentTime <= storeClosed && day != 5) {
      return "OUVERT";
    } else {
      return "FERMÉ";
    }
  }
}
